module.exports = __webpack_public_path__ + "img/w3_chevron_up_black.e46d9f06.png";